// Entry for every brand page and the demo landing. Brand from hostname/query, resources from path/query.
import { hostTenant, resolveBrand, resolveMode, resolveResources, wantsFirstFile } from './route.js';
import { api, loadHostConfig } from './common.js';

const LOADERS = {
  solred: () => import('./brands/solred.js'),
  rapidshare: () => import('./brands/rapidshare.js'),
  lolaup: () => import('./brands/lolaup.js'),
  uptocash: () => import('./brands/uptocash.js'),
  'marketcat-drive': () => import('./brands/marketcat-drive.tsx'),
};
const TITLES = { solred: 'Solred · Descarga', rapidshare: 'Rapidshare', lolaup: 'LolaUp', uptocash: 'UpTo.cash', 'marketcat-drive': 'MarketCat Drive' };

/** Pick a public file from this host's own catalog (largest first) and put its id in the URL. */
async function openFirst() {
  const list = await api().catalog().catch(() => []);
  const r = [...list].sort((a, b) => (b.sizeBytes || 0) - (a.sizeBytes || 0))[0];
  const u = new URL(location.href);
  u.searchParams.delete('open');
  if (r) u.searchParams.set('r', r.resourceId);
  history.replaceState(null, '', u);
  return r ? [r.resourceId] : [];
}

async function boot() {
  const el = document.getElementById('app');
  const tenant = hostTenant(location.hostname);
  if (tenant === 'admin') { location.replace('/admin/'); return; } // admin host serves the admin app only
  await loadHostConfig();
  const brand = resolveBrand(location);
  let ids = resolveResources(location);
  if (!ids.length && brand && wantsFirstFile(location)) ids = await openFirst();
  const mode = resolveMode(location);
  const brandPage = brand && (ids.length || mode === 'upload' || new URLSearchParams(location.search).has('brand') || wantsFirstFile(location));
  if (!brandPage) {
    const { mountLanding } = await import('../landing/landing.js');
    mountLanding(el, { highlight: brand });
    return;
  }
  document.title = TITLES[brand];
  document.documentElement.setAttribute('data-brand', brand);
  document.documentElement.lang = brand === 'solred' ? 'es' : 'en';
  const mod = await LOADERS[brand]();
  const unmount = mod.mount(el, { ids, mode });
  window.addEventListener('pagehide', () => unmount && unmount(), { once: true });
}

boot().catch((e) => {
  console.error(e);
  const el = document.getElementById('app');
  el.textContent = 'This page could not load. Reload to try again.';
});
